<template>
  <Layout>
    <v-row justify="center" class="my-2">
      <v-col>
        <v-card class="mx-auto py-4" width="100%">
          <h3>หมายเลขงาน : {{ $route.params.id }}</h3>
          <h4>ชื่องาน : {{ jobDetailName }} , วันที่: {{ date }}</h4>
          <h4 class="mt-4">
            เวลาที่เริ่ม :
            <span class="time">{{ startTime }}</span> สิ้นสุดเวลา:
            <span class="time">{{ endTime }}</span>
          </h4>
        </v-card>
      </v-col>
    </v-row>
    <template v-if="loading">
      <v-skeleton-loader
        v-bind="attrs"
        type="table-heading, list-item-two-line, image, table-tfoot"
      ></v-skeleton-loader>
    </template>
    <template v-else>
      <v-row>
        <v-col class="d-flex justify-start">
          <v-btn elevation="2" @click="goBack"> ย้อนกลับ </v-btn>
        </v-col>
        <v-col class="d-flex justify-end">
          <v-menu
            :close-on-content-click="closeOnContentClick"
            left
            offset-y
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="primary" dark v-bind="attrs" v-on="on">
                ดาวน์โหลดรายงาน
              </v-btn>
            </template>

            <v-list>
              <template v-for="(item, index) in items">
                <v-list-item
                  v-if="item.enabled"
                  :key="index"
                  :class="item.className"
                  @click="report(item.report)"
                >
                  <v-list-item-title>
                    {{ item.title }}
                  </v-list-item-title>
                </v-list-item>
              </template>
            </v-list>
          </v-menu>
        </v-col>
      </v-row>
      <br />
      <v-row align="center">
        <v-col cols="4">
          <v-text-field
            v-model="searchText"
            label="ค้นหา รหัสสาขา,สาขา"
            append-icon="mdi-magnify"
          ></v-text-field>
        </v-col>
        <v-col cols="3">
          <v-select
            :items="selectStatusItems"
            label="ผลการตรวจนับ"
            item-text="name"
            v-model="statusFilter"
          ></v-select>
        </v-col>
        <v-col cols="2">
          <v-btn elevation="2" @click="clear"> ล้างข้อมูล </v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <TableJobDetail v-if="jobDetail" :data="jobDetail.stores" />
        </v-col>
      </v-row>
    </template>
  </Layout>
</template>

<script>
import Layout from '@/components/Layout'
import TableJobDetail from '@/components/TableJobDetail'
import { mapState } from 'vuex'
export default {
  computed: {
    ...mapState({
      me: (state) => state.me.data,
      jobDetail: (state) => state.job.jobDetail,
      jobDetailLoading: (state) => state.job.isLoading,
    }),
    loading() {
      return this.jobDetailLoading
    },
    jobDetailName() {
      return this.jobDetail?.job?.name ?? ''
    },
    date() {
      return this.jobDetail?.job?.date ?? ''
    },
    startTime() {
      return this.jobDetail?.job?.start_time ?? ''
    },
    endTime() {
      return this.jobDetail?.job?.end_time ?? ''
    },
    items() {
      return [
        {
          title: 'รายงานความคืบหน้า',
          report: 'stockProgress',
          className: 'bg-yellow-light',
          enabled: true,
        },
        {
          title: 'รายงานพนักงานที่ไม่นับสต็อค',
          report: 'employeesNotCheckedStock',
          className: 'bg-yellow-light',
          enabled: true,
        },
        {
          title: 'รายงานการตรวจนับสต็อคของสาขา',
          report: 'stockChecked',
          enabled: this.jobDetail?.job?.cal_at,
        },
        {
          title: 'ประวัติการบันทึกข้อมูลของสาขา',
          report: 'activityLog',
          enabled: true,
        },
        {
          title: 'รายงานผลการตรวจนับของสาขา',
          report: 'jobResult',
          enabled: this.jobDetail?.job?.cal_at,
        },
      ]
    },
    searchText: {
      get() {
        return this.$store.state?.job?.searchJobDetail
      },
      set(value) {
        this.$store.commit('job/SET_SEARCH_JOB_DETAIL', value)
      },
    },
    statusFilter: {
      get() {
        return this.$store.state?.job?.statusJobDetail
      },
      set(value) {
        this.$store.commit('job/SET_STATUS_JOB_DETAIL', value)
      },
    },
  },

  components: {
    TableJobDetail,
    Layout,
  },

  data() {
    return {
      selectStatusItems: [
        {
          name: 'ทั้งหมด',
          value: null,
        },
        {
          name: 'ยังไม่ได้นับ',
          value: 5,
        },
        {
          name: 'สต็อคไม่ตรง',
          value: 6,
        },
        {
          name: 'ไม่มีสต็อคสินค้า',
          value: 7,
        },
        {
          name: 'นับไม่ครบและมีข้อบกพร่อง',
          value: 9,
        },
        {
          name: 'นับครบแต่มีข้อบกพร่อง',
          value: 10,
        },
        {
          name: 'สมบูรณ์',
          value: 8,
        },
      ],
      closeOnContentClick: true,
    }
  },

  async mounted() {
    const payload = {
      id: this.$route.params.id,
    }
    await this.$store.dispatch('job/getJobDetail', payload)
    this.$store.commit('job/RESET_STORE_DETAIL')
    this.$store.commit('job/RESET_STORE_DETAIL_OVER')
  },

  methods: {
    createJob() {
      this.$router.push({
        name: 'CreateJob',
      })
    },

    async report(val) {
      const payload = {
        job_id: this.$route.params.id,
        name: `job_id_${this.$route.params.id}`,
        filter_status: this.statusFilter,
      }
      await this.$store.dispatch(`report/${val}`, payload)
    },

    goBack() {
      this.$store.commit('job/RESET_JOB_DETAIL')
      this.$router.push({ name: 'Dashboard' })
    },

    clear() {
      this.$store.commit('job/RESET_JOB_DETAIL')
    },
  },
}
</script>

<style>
.time {
  padding: 0.2rem 0.5rem;
  background: #d9d9d9;
}
</style>

<style scoped>
/deep/ .v-list-item__title {
  text-align: left;
  line-height: 1.5;
}
</style>
